import { IQuestion } from "../surveyTypes";
const questionReducer = (data: any): IQuestion => {
  return {
    id: data.id,
    questionText: data.question_text,
  };
};

export default questionReducer;
